interface IResearcher {
  uuid: string;
  name: string;
  surnames: string;
}

/**
 * Extracts prescribing doctor information from a submission
 * @param submission - The submission object containing researcher information
 * @returns Researcher object or undefined if no researcher
 */
export const extractPrescribingDoctor = (submission: {
  uuidResearcher?: string;
  researcher?: IResearcher | string;
}): IResearcher | undefined => {
  if (!submission?.researcher) return undefined;
  
  // If researcher is already an object, return it
  if (typeof submission.researcher === 'object') {
    return submission.researcher;
  }
  
  // If researcher is a string, parse it
  return {
    uuid: submission.uuidResearcher || '',
    name: submission.researcher.split(' ')[0] || '',
    surnames: submission.researcher.split(' ').slice(1).join(' ') || '',
  };
};

